import { NoEncryption } from "@mui/icons-material";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import Select from "../../base/select";
import MenuItem from "../../base/menuitem";
import React, { useContext } from "react";

import { FormattedMessage } from "react-intl";

import UserContext from "../../../services/user/user";
import messages_de from "../../../translations/de.json";
import messages_en from "../../../translations/en.json";
import messages_es from "../../../translations/es.json";
import messages_fr from "../../../translations/fr.json";

export default function EDropdown({
  name,
  options,
  setValue,
  label,
  initValue,
  error = false,
  required = false,
  disabled = false,
  placeholder,
  ...props
}) {
  let ddValue = initValue || "";

  const handleChange = (event) => {
    setValue(event.target.value, event.target.name);
  };

  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };
  const { lang } = useContext(UserContext);

  return (
    <React.Fragment>
      <InputLabel
        id={`select-${label}`}
        sx={{ opacity: disabled ? 0.6 : 1, fontWeight: 500 }}
      >
        {/* <FormattedMessage id={label} /> */}
        {typeof messages[lang][label] === "undefined"
          ? label
          : messages[lang][label]}
        {required ? "*" : ""}
      </InputLabel>
      <FormControl
        fullWidth
        error={error}
        sx={{
          ".MuiFilledInput-root::before": {
            display: "none"
          }
        }}
      >
        <Select
          labelId={`select-${label}`}
          id={`simple-select-${label}`}
          value={ddValue}
          label={label}
          onChange={handleChange}
          name={name}
          disabled={disabled}
          variant="filled"
          sx={{
            ".MuiFilledInput-input": {
              pt: "8px"
            }
          }}
          MenuProps={{
            sx: { maxHeight: "250px" },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center"
            }
          }}
          {...props}
        >
          {options.map((option, index) => (
            <MenuItem value={option.value} key={index}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        {error && required ? (
          <FormHelperText>{label} field is required</FormHelperText>
        ) : (
          ""
        )}
      </FormControl>
    </React.Fragment>
  );
}
